export const styles = {
    dialogActions: (isMobile, theme) => ({
        px: isMobile ? 2 : 3,
        pb: isMobile ? 'calc(env(safe-area-inset-bottom) + 16px)' : 3,
        pt: isMobile ? 2 : 3,
        gap: 2,
        borderTop: `1px solid ${theme.palette.divider}`,
        flexDirection: isMobile ? 'column' : 'row',
        '& > button': {
            flex: isMobile ? 1 : 'initial',
            width: isMobile ? '100%' : 'auto'
        }
    }),
    cancelButton: (isMobile) => ({
        borderRadius: 2,
        px: 3,
        textTransform: 'none',
        fontWeight: 600,
        order: isMobile ? 2 : 1
    }),
    submitButton: (isMobile, theme) => ({
        borderRadius: 2,
        px: 3,
        textTransform: 'none',
        fontWeight: 600,
        background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        '&:hover': {
            background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`
        },
        order: isMobile ? 1 : 2
    })
};
